import { useState } from 'react';
import axios from 'axios';

const useAxios = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const post = async (url, payload) => {
    setLoading(true);
    setError('');

    try {
      const res = await axios.post(url, payload, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      setLoading(false);
      return res.data;
    } catch (err) {
      setLoading(false);
      setError(err.response?.data?.message || 'Request failed');
      return null;
    }
  };

  return { post, loading, error };
};

export default useAxios;
